import React, { forwardRef, useEffect, useRef } from 'react';
import classNames from 'classnames';
import { useDispatch, useSelector } from 'react-redux';
import { GetEventJudgeStore } from 'SessionState/Judge/EventJudgeStore';
import { IReduxState } from 'ReduxState';
import { menuChangeAttrMenuAnimate, menuChangeCollapseAll } from './main-menu/menuSlice';
import { MENU_BEHAVIOUR, MENU_PLACEMENT } from 'constants.js';
import JudgeNavLogo from './JudgeNavLogo';
import JudgeNavIconMenu from './JudgeNavIconMenu';
import useCustomLayout from 'hooks/useCustomLayout';

type JudgeNavProps = {
  children?: React.ReactNode;
  className?: string;
  onLogout?: () => void | Promise<void>;
};

const DELAY = 80;

const JudgeNav = forwardRef<HTMLDivElement, JudgeNavProps>(
  ({ children, className, onLogout }, observer) => {
  const { navClasses, placementStatus, behaviourStatus, attrMobile, menuPadding } = useSelector((state: IReduxState) => state.menu);

  const judgeStore = GetEventJudgeStore();
  const judge = judgeStore.CurrentJudge;
  const isLoggedIn = !!judge;

    const dispatch = useDispatch();

   const mouseActionTimer = useRef(null);
  
    // Vertical menu semihidden state showing
    // Only works when the vertical menu is active and mobile menu closed
    const onMouseEnterDelay = () => {
      if (placementStatus.placementHtmlData === MENU_PLACEMENT.Vertical && behaviourStatus.behaviourHtmlData === MENU_BEHAVIOUR.Unpinned && attrMobile !== true) {
        dispatch(menuChangeCollapseAll(false));
        dispatch(menuChangeAttrMenuAnimate('show'));
      }
    };
  

    useCustomLayout({ placement: MENU_PLACEMENT.Vertical });

  

  return (
    <div id="nav" className={classNames('nav-container d-flex', navClasses)} >
      <div
        className="nav-content d-flex justify-content-between"
        style={placementStatus.placementHtmlData === MENU_PLACEMENT.Horizontal && menuPadding ? { paddingRight: menuPadding } : {}}
      >
               <JudgeNavLogo />
        
          {isLoggedIn && (
            <div className="d-none d-md-flex flex-column align-items-center justify-content-center text-center">
              <div className="fw-bold fs-5 text-body">{judge.eventName}</div>
            </div>
          )}

          <div className="d-flex align-items-start justify-content-end">
            {isLoggedIn ?  (<JudgeNavIconMenu onLogout={onLogout} />) : (
                <div className="fw-bold fs-5 text-body">JUDGES PORTAL</div>
            )}
          </div>

        {children && <div className="pb-2">{children}</div>}
      </div>
    </div>
  );
});

JudgeNav.displayName = 'JudgeNav';

export default React.memo(JudgeNav);